import { Button, Col, Icon, Layout, Row, Spin, Switch, Table, Tooltip, Collapse, Input, Tag } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Constant } from '../../../config';
import { fetchMenuAction } from '../../../store/actions/leftSideMenu';
import MyModal from '../../Modal';
import SearchForm from '../../SearchForm';
import '../style.css';
import BlackholeForm from './form';

const { Content } = Layout;
const { Panel } = Collapse;
const KEYWORD_BLACKHOLE_FLAG_UPDATEING_KEY = 'keyword-blackhole-flagUpdatingData';

class BlackHole extends Component {
  state = {
    currentData: {
      id: 0,
      keyword: '',
    },
    currentPage: 1,
    currentSearch: '',
    dataSource: [],
    flagCreateOrUpdateForm: true,
    flagStatusToggle: {},
    isReload: false,
    loading: false,
    totalRows: 0,
    visibleFormModal: false,

    chackBhText: '',
    checkBhLoading: false,
    checkBHShowResult: false,
    checkBH : {
      count : 0,
      exclude : [],
      isBlackhole : false
    }
  };

  columns = [
    {
      align: 'center',
      dataIndex: 'created_date',
      render: (createdDate) => {
        if (!createdDate) return '-';

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {createdDate}
          </Moment>
        );
      },
      title: 'วัน / เวลา สร้าง',
      width: '150px',
    },
    {
      dataIndex: 'keyword',
      title: 'Keywords',
      width: '300px',
    },
    {
      align: 'center',
      dataIndex: 'status',
      render: (status, record) => {
        return (
          <Switch
            checkedChildren={<Icon type="check" />}
            checked={this.state.flagStatusToggle[record.id]}
            unCheckedChildren={<Icon type="close" />}
            onChange={(e, event) => {
              event.stopPropagation();
              return this.toggleStatus(e, record.id);
            }}
          />
        );
      },
      title: 'เปิด / ปิด',
      width: '100px',
    },
    {
      align: 'center',
      dataIndex: 'id',
      render: (id, record) => (
        <span>
          <Tooltip title="แก้ไข">
            <Button
              icon="edit"
              onClick={() => this.edit(record)}
              style={{ marginRight: '5px' }}
              type="primary"
            />
          </Tooltip>
          <Tooltip title="ลบ">
            <Button icon="delete" onClick={() => this.delete(id)} type="danger" />
          </Tooltip>
        </span>
      ),
      title: 'ดำเนินการ',
    },
  ];
  columnsMobile = [];
  limit = 10;

  componentWillMount() {
    this.props.fetchMenuAction('keyword', 'keyword-blackhole');
    this.setState({ loading: true });
  }

  async componentDidMount() {
    let isReload = this.state.isReload;
    const tmp = window.localStorage.getItem(KEYWORD_BLACKHOLE_FLAG_UPDATEING_KEY);
    if (+tmp === 1) isReload = true;

    await this.getDataList();
    this.setState({
      flagStatusToggle: this.setFlagStatusToggle(),
      isReload,
      loading: false,
    });
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(page, this.state.currentSearch);

    this.setState({
      flagStatusToggle: this.setFlagStatusToggle(),
      loading: false,
    });
  };

  create = () => {
    this.setState({
      currentData: {
        id: 0,
        keyword: '',
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: true,
    });
  };

  delete = (id = 0) => {
    if (id === 0) {
      window.location.reload();
      return;
    }

    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.KEYWORD_BLACKHOLE_API}/${id}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'DELETE',
      url,
    };

    MyModal.confirm(
      `คุณต้องการลบรายการนี้ ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios(opt);
        } catch (e) {
          console.error(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
          return;
        }

        MyModal.success(`ลบรายการ สำเร็จ`);

        await this.getDataList();

        window.localStorage.setItem(KEYWORD_BLACKHOLE_FLAG_UPDATEING_KEY, '1');

        this.setState({
          flagStatusToggle: this.setFlagStatusToggle(),
          isReload: true,
          loading: false,
        });
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  edit = (d) => {
    if (!d || d.id === 0) return;

    this.setState({
      currentData: {
        id: d.id,
        keyword: d.keyword,
      },
      flagCreateOrUpdateForm: false,
      visibleFormModal: true,
    });
  };

  formHandleCancel = () => {
    this.setState({
      currentData: {
        id: 0,
        keyword: '',
      },
      flagCreateOrUpdateForm: true,
      visibleFormModal: false,
    });
  };

  formHandleSubmit = () => {
    const { form } = this.formRef.props;

    form.validateFields((err, values) => {
      if (err) return;

      MyModal.confirm('ยืนยันบันทึกข้อมูล ใช่หรือไม่ ?', '', async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({
          loading: true,
          visibleFormModal: false,
        });

        const modeText = this.state.flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
        const errorMsg = `เกิดข้อผิดพลาด ไม่สามารถ${modeText}ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
        const token = localStorage.getItem(Constant.SessionKey);
        let url = Constant.KEYWORD_BLACKHOLE_API;
        if (!this.state.flagCreateOrUpdateForm) url += `/${values.id}`;

        const opt = {
          data: values,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          method: this.state.flagCreateOrUpdateForm ? 'POST' : 'PUT',
          url,
        };

        try {
          await axios(opt);

          if (this.state.flagCreateOrUpdateForm) form.resetFields();

          MyModal.success(`${modeText}ข้อมูลสำเร็จ`, '', async () => {
            await this.getDataList();

            window.localStorage.setItem(KEYWORD_BLACKHOLE_FLAG_UPDATEING_KEY, '1');

            this.setState({
              currentData: { id: 0, keyword: '' },
              flagCreateOrUpdateForm: true,
              flagStatusToggle: this.setFlagStatusToggle(),
              isReload: true,
              loading: false,
            });
          });
        } catch (e) {
          console.error(e);
          MyModal.error(errorMsg, '', () => window.location.reload());
        }
      });
    });
  };

  getDataList = async (page = 1, search = '') => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.KEYWORD_BLACKHOLE_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        page,
        limit: this.limit,
        search,
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      this.initialState();
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  initialState = () => {
    this.setState({
      currentData: { id: 0, keyword: '' },
      currentPage: 1,
      currentSearch: '',
      flagCreateOrUpdateForm: true,
      flagStatusToggle: {},
      dataSource: [],
      loading: false,
      totalRows: 0,
      visibleFormModal: false,
    });
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      this.setState({
        currentPage: 1,
        currentSearch: values.searchTxt,
        loading: true,
      });

      await this.getDataList(1, values.searchTxt);

      this.setState({ loading: false });
    });
  };

  reload = async () => {
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.KEYWORD_BLACKHOLE_API}/blackhole/cache`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'DELETE',
      url,
    };

    MyModal.confirm(
      `คุณต้องการ Reload ข้อมูล ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios(opt);
        } catch (e) {
          console.error(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
          return;
        }

        MyModal.success(`Reload ข้อมูล สำเร็จ`);

        await this.getDataList();

        window.localStorage.removeItem(KEYWORD_BLACKHOLE_FLAG_UPDATEING_KEY);

        this.setState({
          flagStatusToggle: this.setFlagStatusToggle(),
          isReload: false,
          loading: false,
        });
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  resetSearch = async () => {
    this.initialState();
    this.setState({ loading: true });

    await this.getDataList(1);

    this.setState({
      flagStatusToggle: this.setFlagStatusToggle(),
      loading: false,
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  setFlagStatusToggle = () => {
    const d = this.state.dataSource;
    let rtn = {};
    for (let i = 0; i < d.length; i++) rtn[d[i].id] = d[i].status === 'enabled';

    return rtn;
  };

  toggleStatus = (f, id = 0) => {
    if (id === 0) {
      window.location.reload();
      return;
    }

    const token = localStorage.getItem(Constant.SessionKey);
    const textConfirm = `${f ? 'เปิด' : 'ปิด'}`;
    const url = `${Constant.KEYWORD_BLACKHOLE_API}/${id}/${f ? 'enabled' : 'disabled'}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'PUT',
      url,
    };

    MyModal.confirm(
      `ยืนยัน ${textConfirm}การใช้งาน ใช่หรือไม่ ?`,
      '',
      async (isConfirm) => {
        if (!isConfirm) return;

        this.setState({ loading: true });

        try {
          await axios(opt);
        } catch (e) {
          console.error(e);
          MyModal.error('เกิดข้อผิดพลาด ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง');
          this.setState({ loading: false });
          return;
        }

        MyModal.success(`${textConfirm} สำเร็จ`);

        let tmp = this.state.flagStatusToggle;
        tmp[id] = f;

        window.localStorage.setItem(KEYWORD_BLACKHOLE_FLAG_UPDATEING_KEY, '1');

        this.setState({
          flagStatusToggle: tmp,
          isReload: true,
          loading: false,
        });
      },
      'ยืนยัน',
      'ยกเลิก',
    );
  };

  onClickCheckBH = async () => {
    let resp;
    const message = this.state.chackBhText
    if(message.length === 0) {
      return
    }

    this.setState({ checkBhLoading: true })

    const url = `${Constant.KEYWORD_BLACKHOLE_API}/checkbh`;
    const opt = {
      method: 'POST',
      url,
      data: this.state.chackBhText,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");

      const checkBH = resp.data;
      this.setState({
        checkBH : {
          ...checkBH,
          isBlackhole : checkBH.is_blackhole
        },
        checkBhLoading: false,
        checkBHShowResult: true,
        
      })
      
    } catch (e) {
      console.error(e);
      this.setState({
        checkBhLoading: false,
        checkBHShowResult: false,
        checkBhText: '',
      })
      return;
    }

  }

  renderExclude = () => {
    const {count, exclude} = this.state.checkBH
    if (count === 0) {
      return <div></div>
    }

    const renderItem = []
    const colour = ["magenta", "red", "volcano", "orange", "gold", "lime", "green", "cyan", "blue", "geekblue", "purple"]
    for (const keyword of exclude) {
      const randomI = Math.floor(Math.random() * count)
      const item = <Tag color={colour[randomI]}>{keyword}</Tag>
      renderItem.push(item)
    }

    return renderItem
  }

  render() {
    const propsTable = {
      bordered: true,
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
      size: 'small',
    };
    const propsTableForMobile = Object.assign({}, propsTable);

    propsTableForMobile.className = 'my-table-mobile';
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>Blackhole Keyword</h2>
            <p className="header-desc">Keyword ที่ไม่อนุญาตให้ใช้งาน</p>
            <Collapse style={{
              margin: '16px 0',
            }}>
              <Panel header="Check Blackhole Keyword">
                <Row gutter={16} type="flex" justify="center" align="middle" style={{margin: '16px 0'}}>
                  <Col span={20}>
                  <Input.TextArea disabled={this.state.checkBhLoading} value={this.state.chackBhText} onChange={(e) => this.setState({ chackBhText : e.target.value })} placeholder='กรอกข้อความเพื่อเช็ค blackhole' />
                  </Col>
                  <Col span={2}>
                    <Button type='primary' loading={this.state.checkBhLoading} onClick={this.onClickCheckBH}>
                      Check
                      </Button>
                  </Col>
                  <Col span={2}>
                    <Button type='dashed' onClick={() => this.setState({
                       chackBhText: '',
                       checkBhLoading: false,
                       checkBHShowResult: false,
                       checkBH : {
                         count : 0,
                         exclude : [],
                         isBlackhole : false
                       }
                    })}>
                      Clear
                      </Button>
                  </Col>
                </Row>

                { this.state.checkBHShowResult && (
                  <div>
                  <p><span style={{fontWeight: 'bold'}}>Check Result</span>: {this.state.checkBH.isBlackhole ? <span style={{color:'red'}}>Blackhole</span> : <span style={{color:'green'}}>Pass</span>}</p> 
                  <p><span style={{fontWeight: 'bold'}}>Count</span>: {this.state.checkBH.count}</p> 
                  <p><span style={{fontWeight: 'bold'}}>Exclude Text</span>: {this.renderExclude()}</p>
                  </div>
                )  }
              </Panel>
            </Collapse>
            <Row className="utility-bar">
              <Col span={12}>
                <Button className="add-btn" onClick={() => this.create()}>
                  <Icon type="plus-circle" />
                  เพิ่ม
                </Button>
                {/* <Button
                  type="primary"
                  onClick={() => this.reload()}
                  disabled={!this.state.isReload}
                >
                  <Icon type="reload" />
                  Reload
                </Button>
                {this.state.isReload ? (
                  <span className="note-danger">
                    * กรุณากดปุ่ม Reload เพื่ออัพเดตข้อมูลใหม่
                  </span>
                ) : null} */}
              </Col>
              <Col span={12}>
                <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <Button block>
                <Icon type="plus-circle" />
                เพิ่ม
              </Button>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
          </Content>
        </Spin>
        <BlackholeForm
          wrappedComponentRef={this.saveFormRef}
          flagCreateOrUpdateForm={this.state.flagCreateOrUpdateForm}
          loading={this.state.loading}
          onCancel={this.formHandleCancel}
          onCreate={this.formHandleSubmit}
          visible={this.state.visibleFormModal}
          data={this.state.currentData}
        />
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(BlackHole);



// WEBPACK FOOTER //
// ./src/containers/Keyword/Blackhole/index.js